import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-provider-logo',
  template: `
    @if (logoUrl) {
      <div
        class="logo padding-vertical-8"
        [ngStyle]="{ 'background-image': 'url(' + logoUrl + ' )' }"
      ></div>
    }
  `,
  styleUrls: ['./provider-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProviderLogoComponent implements OnInit {
  @Input() logoUrl?: string;
  constructor() {}

  ngOnInit() {}
}
